package chat.amp.tim

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.unit.dp
import de.connect2x.messenger.compose.view.theme.ComponentStyles
import de.connect2x.messenger.compose.view.theme.ThemeComponents
import de.connect2x.messenger.compose.view.theme.ThemeComponentsImpl
import de.connect2x.messenger.compose.view.theme.components.SurfaceStyle

/**
 * The messenger's own styling with the changes the flat design asks for: white surfaces,
 * the selected room in the strong brand colour, pale own message bubbles and filled date
 * labels. Everything else is inherited from [ThemeComponentsImpl], so updates of the
 * messenger library keep working.
 *
 * Two things the mock-up shows cannot be set here, see docs/variantenmanagement.md:
 * the "not verified" banner (the library draws it with `errorBanner`) and the state events
 * in the timeline (hard wired to the `tertiary` colour role).
 */
class ampThemeComponentsFlatImpl : ThemeComponents {
    @Composable
    override fun create(): ComponentStyles {
        val colors = MaterialTheme.colorScheme
        return ThemeComponentsImpl().create().copy(
            // white instead of the tinted container colours
            sidebar = SurfaceStyle.default(color = colors.surfaceContainerLowest),
            header = SurfaceStyle.default(color = colors.surfaceContainerLowest),
            // the selection carries the brand colour, not its pale container
            roomListSelection = SurfaceStyle.default(
                color = colors.primary,
                contentColor = colors.onPrimary,
            ),
            // own messages pale, so the timeline stays quiet
            messageBubbleOwn = SurfaceStyle.default(
                color = colors.primaryContainer,
                contentColor = colors.onPrimaryContainer,
                shape = RoundedCornerShape(8.dp),
            ),
            // date labels filled instead of outlined
            label = SurfaceStyle.default(
                color = colors.secondary,
                contentColor = colors.onSecondary,
                shape = RoundedCornerShape(16.dp),
                contentPadding = PaddingValues(horizontal = 8.dp, vertical = 3.dp),
                textStyle = MaterialTheme.typography.bodySmall,
            ),
        )
    }
}
